<template>
  <div id="theme-customizer" v-if="active">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="active"
      class="items-no-padding">
      <div class="h-full">
        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>Chart Create</h4>
          </div>
          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0"/>

        <div class="vx-row mb-3 mt-4 px-4">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Chart</small>
            <v-select :clearable="false" placeholder="" v-model="chart_obj"
                      v-on:input="onSelectChart"
                      :options="chart_list"
                      label="label"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>

        <div class="vx-row mb-3 px-4">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Chart Name</small>
            <vs-input v-model="form.chart_name" name="xaxis_title" class="w-full required" label=""/>
          </div>
        </div>

        <div class="vx-row mb-8 px-4" v-if="form.report_type !== 'table'">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Chart Type</small>
            <v-select :clearable="false" placeholder="" v-model="form.chart_type"
                      :options="['line', 'bar', 'area', 'scatter', 'pie']"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>

        <div class="vx-row mb-3 px-4" v-if="form.chart_type !== 'pie' && form.report_type !== 'table'">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">X axis title</small>
            <vs-input v-model="form.xaxis" name="xaxis_title" class="w-full required" label=""/>
          </div>
        </div>

        <div class="vx-row mb-8 px-4" v-if="form.chart_type !== 'pie' && form.report_type !== 'table'">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Y axis title</small>
            <vs-input v-model="form.yaxis" name="yaxis_title" class="w-full required" label=""/>
          </div>
        </div>

        <div class="vx-row mb-3 px-4" v-if="form.report_type !== 'table'">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Interval</small>
            <v-select :clearable="false" placeholder="" v-model="form.interval"
                      :options="['daily', 'weekly', 'monthly']"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>
        <div class="vx-row mb-3 px-4">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Range</small>
            <v-select :clearable="false" placeholder="" v-model="form.range"
                      :options="range_list"
                      label="label"
                      :reduce="option => option.value"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>

        <div class="vx-row my-5 mx-3">
          <div class="vx-col w-full ml-auto">
            <vs-button @click.stop="onClickSave" class="float-right w-full my-4" size="small" color="primary"
                       type="border" icon-pack="feather" icon="icon-save">CREATE
            </vs-button>
          </div>
        </div>

      </div>
    </vs-sidebar>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import chart_data from '@/constants/charts'

import {RepositoryFactory} from '@/repository/RepositoryFactory'
import ErrorMessages from '@/mixins/ErrorMessages'
import SuccessMessage from '@/mixins/SuccessMessage'
import {mapGetters} from 'vuex'

const ReportingRepository = RepositoryFactory.get('reporting')

export default {
  name: 'ChartConfigsSideBar',
  data() {
    return {
      active: false,
      chart_data,
      line_chart_data: {},
      pie_chart_data: {},
      chart_obj: {},
      form: {
        chart_type: 'area',
        chart_name: '',
        xaxis: '',
        yaxis: '',
        range: '30',
        interval: 'daily'
      },
      allowed_chart_list: [],
      chart_list: [
        {
          label: 'Actual vs Planned Work Order',
          end_point: 'work-order-statistics',
          filters: [{name: 'status', label: 'Status', key: 'status', value: []},],
          yaxis: 'Work Order',
          xaxis: 'Time',
          report_type: 'graph'
        },
        {
          label: 'All Sales Margin Table',
          end_point: 'all-sales-margin-table',
          filters: [
            {name: 'currencies', label: 'Account Currency', key: 'account_currency', value: [], multiple: true},
            {name: 'account_type', label: 'Account Type', key: 'account_type', value: [], multiple: false},
          ],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'sales_order_number', name: 'Order Number'},
            {key: 'product_code', name: 'Product Code'},
            {key: 'invoice_date', name: 'Invoice Date'},
            {key: 'invoice_number', name: 'Invoice No'},
            {key: 'customer', name: 'Customer'},
            {key: 'customer_currency', name: 'Currency'},
            {key: 'invoice_quantity', name: 'Invoice Quantity (KG)'},
            {key: 'unit_price', name: 'Unit Price'},
            {key: 'total_price', name: 'Total Price'},
            {key: 'order_quantity', name: 'Order Quantity'},
            {key: 'rm_cost', name: 'RM Cost'},
            {key: 'sundry_cost', name: 'Sundry Cost'},
            {key: 'labour_cost', name: 'Labour Cost'},
            {key: 'machine_cost', name: 'Machine Cost'},
            {key: 'total_cost', name: 'Total Cost'},
            {key: 'margin', name: 'Margin'},
            {key: 'margin_percentage', name: 'Margin Percentage (%)'},
          ],
          view_download_button: 'sales-margin-report'
        },
        {
          label: 'Customers First Sample Order',
          end_point: 'customer-first-sample-order',
          filters: [{name: 'interval', label: 'Interval', key: 'interval', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'customer_code', name: 'Customer Code'},
            {key: 'customer_name', name: 'Customer Name'},
          ]
        },
        {
          label: 'Customers Using System',
          end_point: 'no-customer-using',
          filters: [{name: 'interval', label: 'Interval', key: 'interval', value: []},],
          yaxis: '',
          xaxis: 'Time',
        },
        {
          label: 'Customer Debtor Value',
          end_point: 'customer-debtor-values',
          filters: [
            {name: 'customers', label: 'Customer', key: 'customer_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
          ],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'customer_name', name: 'Customer Name'},
            {key: 'customer_account_number', name: 'Customer Account Number'},
            {key: 'value', name: 'Value'},
            {key: 'date', name: 'Date'},
            {key: 'created_at', name: 'Created At'},
          ],
        },
        {
          label: 'Customer vs Sample Order',
          end_point: 'customer-sample-order',
          filters: [{name: 'customers', label: 'Customer', key: 'customer_id', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'customer_code', name: 'Customer Code'},
            {key: 'customer_name', name: 'Customer Name'},
            {key: 'no_of_items', name: 'No Of Items'},
          ]
        },
        {
          label: 'Delayed orders',
          end_point: 'delayed-orders',
          filters: [{name: 'countries', label: 'Country', key: 'country', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'product_order_code', name: 'Product Order Code'},
            {key: 'country', name: 'Country'},
            {key: 'customer_code', name: 'Customer Code'},
            {key: 'customer_name', name: 'Customer Name'},
            {key: 'created_at', name: 'Created At'},
          ],
          expanded_table: {
            data_key: 'items',
            data_label: 'Order Items',
            table_keys: [
              {key: 'formulation_code', name: 'Formulation Code'},
              {key: 'item_status', name: 'Item Status'},
              {key: 'required_by', name: 'Required By'},
              {key: 'price', name: 'Price (GBP)'},
              {key: 'pending_dispatch_quantity', name: 'Pending Dispatch Quantity (KG)'},
              {key: 'pending_manufacture_quantity', name: 'Pending Man Quantity (KG)'},
              {key: 'quantity', name: 'Quantity (KG)'},
            ],
          },
          view_download_button: 'delayed-product-orders-report'
        },
        {
          label: 'Formulation Stock Pending Dispatch',
          end_point: 'formulation-stock-pending-dispatch',
          filters: [{name: 'Formulation', label: 'Formulation', key: 'formulation_id', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'formulation_code', name: 'Formulation Code'},
            {key: 'total_quantity', name: 'Total Quantity'},
            {key: 'completed_quantity', name: 'Completed Quantity'},
            {key: 'status', name: 'Status'},
            {key: 'manufacture_date', name: 'Manufacture Date'},
            {key: 'expiration_date', name: 'Expiration Date'},
          ]
        },
        {
          label: 'GRNI',
          end_point: 'grni-statistics',
          filters: [{name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'type', name: 'Order Type'},
            {key: 'order_number', name: 'Order Number', link: true, link_key: 'order_id'},
            {key: 'supplier_name', name: 'Supplier Name'},
            {key: 'supplier_account_number', name: 'Supplier Account Number'},
            {key: 'created_at', name: 'Created At'},
          ]
        },
        {
          label: 'List of Credit Limit Requests',
          end_point: 'credit-limit',
          filters: [{name: 'search', label: 'Search', key: 'search', value: [], type: 'input-field'},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'created_at', name: 'Created Date'},
            {key: 'created_by', name: 'Created By'},
            {key: 'customer_name', name: 'Customer Name'},
            {key: 'customer_account_number', name: 'Customer Account Number'},
            {key: 'change_to', name: 'Requested Amount'},
            {key: 'reason_for_change', name: 'Reason for Change'},
            {key: 'valid_till', name: 'Valid Till'},
            {key: 'status', name: 'Request Status'},
            {key: 'status_reason', name: 'Status Changed Reason'},
            {key: 'approved_by', name: 'Approved By'},
          ]
        },
        {
          label: 'List of all Formulation Stock',
          end_point: 'formulation-stock',
          filters: [{name: 'Formulation', label: 'Formulation', key: 'formulation_id', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'formulation_code', name: 'Formulation Code'},
            {key: 'total_quantity', name: 'Total Quantity'},
            {key: 'completed_quantity', name: 'Completed Quantity'},
            {key: 'status', name: 'Status'},
            {key: 'manufacture_date', name: 'Manufacture Date'},
            {key: 'expiration_date', name: 'Expiration Date'},
          ]
        },
        {
          label: 'Month End Sales Report',
          end_point: 'all-sales-margin-table',
          filters: [
            {name: 'currencies', label: 'Account Currency', key: 'account_currency', value: [], multiple: true},
            {name: 'account_type', label: 'Account Type', key: 'account_type', value: [], multiple: false},
          ],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'sales_order_number', name: 'Order Number'},
            {key: 'product_code', name: 'Product Code'},
            {key: 'invoice_date', name: 'Invoice Date'},
            {key: 'invoice_number', name: 'Invoice No'},
            {key: 'customer', name: 'Customer'},
            {key: 'customer_currency', name: 'Currency'},
            {key: 'invoice_quantity', name: 'Invoice Quantity (KG)'},
            {key: 'unit_price', name: 'Unit Price'},
            {key: 'total_price', name: 'Total Price'},
            {key: 'order_quantity', name: 'Order Quantity'},
            {key: 'rm_cost', name: 'RM Cost'},
            {key: 'sundry_cost', name: 'Sundry Cost'},
            {key: 'labour_cost', name: 'Labour Cost'},
            {key: 'machine_cost', name: 'Machine Cost'},
            {key: 'total_cost', name: 'Total Cost'},
            {key: 'margin', name: 'Margin'},
            {key: 'margin_percentage', name: 'Margin Percentage (%)'},
          ],
          view_download_button: 'month-end-sales-report'
        },
        {
          label: 'Other Orders Expenditure',
          end_point: 'other-expenditure',
          filters: [
            {name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
          ],
          yaxis: 'Expenditure (GBP)',
          xaxis: 'Time',
          report_type: 'graph'
        },
// {
//   label: 'Outstanding Orders', end_point: 'outstanding-orders',
//   filters: [
//     {name: 'countries', label: 'Country', key: 'country', value: []},
//   ],
//   yaxis: '', xaxis: '',
//   report_type: 'table',
//   table_keys:[
//     {key:'product_order_code', name: 'Product Order Code'},
//     {key:'country', name: 'Country'},
//     {key:'customer_code', name: 'Customer Code'},
//     {key:'customer_name', name: 'Customer Name'},
//     {key:'created_at', name: 'Created At'},
//     {key:'status', name:'Status'}
//   ],
//   expanded_table: {
//     data_key: 'items',
//     data_label: 'Order Items',
//     table_keys: [
//       {key:'formulation_code', name: 'ITS Product Code'},
//       {key:'incoterm', name: 'Incoterm'},
//       {key:'required_by', name: 'Required By'},
//       {key:'item_status', name: 'Order Item Status'},
//       {key:'quantity', name: 'Quantity (KG)'},
//       {key:'price', name: 'Price (GBP)'},
//       {key:'pending_dispatch_quantity', name: 'Pending Dispatch Quantity (KG)'},
//       {key:'pending_manufacture_quantity', name: 'Pending Manufacture Quantity (KG)'},
//     ],
//   },
//   view_download_button: 'outstanding-product-orders-report'
// },
        {
          label: 'Product vs Customer',
          end_point: 'product-vs-customer',
          filters: [
            {name: 'customers', label: 'Customer', key: 'customer_id', value: []},
            {name: 'Formulation', label: 'Formulation', key: 'formulation_id', value: []},
          ],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'formulation_code', name: 'Formulation Code'},
            {key: 'formulation_name', name: 'Formulation Name'},
          ],
          expanded_table: {
            data_key: 'orders',
            data_label: 'Orders',
            table_keys: [
              {key: 'product_order_code', name: 'Product Order Code'},
              {key: 'item_status', name: 'Item Status'},
              {key: 'customer_currency', name: 'Customer Currency'},
              {key: 'quantity', name: 'Quantity (KG)'},
              {key: 'price', name: 'Price'},
              {key: 'total', name: 'Total'},
              {key: 'customer_name', name: 'Customer Name'},
            ],
          },
          view_download_button: 'product-vs-customer-report'
        },
        {
          label: 'Raw Material Consumption Report',
          end_point: 'consumption-report/raw-material',
          filters: [
            {name: 'suppliers', label: 'Suppliers', key: 'supplier-id', value: [],  multiple: true, raw_filters: true},
            {name: 'raw_materials', label: 'Raw Materials', key: 'raw-material-id', value: [],  multiple: true, raw_filters: true},
          ],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'opening_balance', name: 'Opening Balance (GBP)'},
            {key: 'purchased_amount', name: 'Purchased Amount (GBP)'},
            {key: 'consumed_amount', name: 'Consumed Amount (GBP)'},
            {key: 'closing_balance', name: 'Closing Balance (GBP)'},
            {key: 'change_in_period', name: 'Change in Period (GBP)'},
            {key: 'days', name: 'Days'},
            {key: 'avg_consumption_per_day', name: 'Avg Consumption Per Day (GBP)'},
            {key: 'stock_days_held', name: 'Stock Days Held (GBP)'},
          ],
          view_download_button: [
            {
              title: 'Download Full Consumption Report',
              end_point: 'raw-material-consumption-report'
            },
            {
              title: 'Download RM by WO Details',
              end_point: 'raw-material-batch-consumption-document'
            }
          ]
        },
        {
          label: 'Raw Material Expenditure',
          end_point: 'raw-material-expenditure',
          filters: [
            {name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
          ],
          yaxis: 'Expenditure (GBP)',
          xaxis: 'Time',
          report_type: 'graph'
        },

        {
          label: 'Raw Material Margin',
          end_point: 'raw-material-margin',
          filters: [{name: 'interval', label: 'Interval', key: 'interval', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'code', name: 'Code'},
            {key: 'actual', name: 'Actual'},
            {key: 'expected', name: 'Expected'},
            {key: 'quantity', name: 'Quantity'},
            {key: 'variance_amount', name: 'Variance Amount'},
            {key: 'variance_percent', name: 'Variance Percent'},
          ]
        },
        {
          label: 'Sample Order Statistics',
          end_point: 'sample-order-statistics',
          filters: [
            {name: 'interval', label: 'Interval', key: 'interval', value: []},
            {name: 'status', label: 'Status', key: 'status', value: []},
          ],
          yaxis: '',
          xaxis: 'Time',
        },
        {
          label: 'Sample Order Sectors',
          end_point: 'sample-order-sectors',
          filters: [
          ],
          yaxis: 'Count',
          xaxis: 'Sectors',
        },
        {
          label: 'Sample vs Sale',
          end_point: 'sale-sample-order',
          filters: [{name: 'countries', label: 'Country', key: 'country', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'formulation_code', name: 'Formulation Code'},
            {key: 'formulation_name', name: 'Formulation Name'},
            {key: 'sample_quantity', name: 'Sample Quantity'},
            {key: 'order_quantity', name: 'Order Quantity'}
          ]
        },
        {
          label: 'Sales Revenue Actual vs Budget',
          end_point: 'sales-actual-vs-budget',
          filters: [{name: 'interval', label: 'Interval', key: 'interval', value: []},],
          yaxis: '',
          xaxis: 'Time',
          report_type: 'multi_line_graph'
        },
        {
          label: 'Sales Revenue',
          end_point: 'sales-revenue',
          filters: [
            {name: 'customers', label: 'Customer', key: 'customer_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
            {name: 'staffs', label: 'Account Handler', key: 'account_handler_id', value: [], multiple: true},
            {name: 'industrial_sectors', label: 'Industrial Sector', key: 'industry_sector', value: [], multiple: true},
            {name: 'currencies', label: 'Account Currency', key: 'account_currency', value: [], multiple: true},
          ],
          yaxis: 'Sales Revenue (GBP)',
          xaxis: 'Time',
          report_type: 'graph',
          view_download_button: 'sales-report'
        },
        {
          label: 'Sales Order Received',
          end_point: 'sales-order',
          filters: [
            {name: 'customers', label: 'Customer', key: 'customer_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
            {name: 'staffs', label: 'Account Handler', key: 'account_handler_id', value: []},
            {name: 'order_statuses', label: 'Order Item Status', key: 'item-status', value: [], multiple: true},
          ],
          yaxis: 'Sales Orders',
          xaxis: 'Time',
          report_type: 'graph',
          view_download_button: 'sales-order-report'
        },
        {
          label: 'Supplier Creditor Value',
          end_point: 'supplier-creditor-values',
          filters: [{name: 'countries', label: 'Country', key: 'country', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'supplier_name', name: 'Supplier Name'},
            {key: 'supplier_account_number', name: 'Supplier Account Number'},
            {key: 'value', name: 'Value'},
            {key: 'date', name: 'Date'},
            {key: 'created_at', name: 'Created At'},
          ]
        },
        {
          label: 'Sundry Items Consumption Report',
          end_point: 'consumption-report/sundry',
          hide_chart: false,
          filters: [
            {name: 'suppliers', label: 'Suppliers', key: 'sundry-supplier-id', value: [],  multiple: true, raw_filters: true},
          ],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'opening_balance', name: 'Opening Balance'},
            {key: 'purchased_amount', name: 'Purchased Amount'},
            {key: 'consumed_amount', name: 'Consumed Amount'},
            {key: 'closing_balance', name: 'Closing Balance'},
            {key: 'change_in_period', name: 'Change in Period'},
            {key: 'days', name: 'Days'},
            {key: 'avg_consumption_per_day', name: 'Avg Consumption Per Day'},
            {key: 'stock_days_held', name: 'Stock Days Held'},
          ],
          view_download_button: [
            {
              title: 'Download Full Consumption Report',
              end_point: 'sundry-items-consumption-report'
            },
            {
              title: 'Download Sundry Batch Consumption Report',
              end_point: 'sundry-batch-consumption-document'
            }
          ]
        },
        {
          label: 'Formulation Batch Consumption Report',
          end_point: 'consumption-report/formulation-batch-usage',
          hide_chart: true,
          filters: [
          ],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [],
          view_download_button: [
            {
              title: 'Download Formulation Batch Consumption Report',
              end_point: 'formulation-batch-consumption-report'
            }
          ]
        },
        {
          label: 'Sundry Expenditure',
          end_point: 'sundry-expenditure',
          filters: [
            {name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
          ],
          yaxis: 'Expenditure (GBP)',
          xaxis: 'Time',
          report_type: 'graph'
        },
        {
          label: 'Supplier Accreditations',
          end_point: 'supplier-site-accreditation',
          filters: [{name: 'search', label: 'Search', key: 'search', value: [], type: 'input-field'},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'created_at', name: 'Created Date'},
            {key: 'expiry', name: 'Expiry Date'},
            {key: 'supplier_name', name: 'Supplier Name'},
            {key: 'site_name', name: 'Site Name'},
            {key: 'type', name: 'Type'},
            {key: 'name', name: 'Accreditation Name'},
            {key: 'grade', name: 'Grade'},
            {key: 'body', name: 'Content'},
          ]
        },
        {
          label: 'Top 20 Customers Actual & Budget',
          end_point: 'top-20-customer-actual-budget',
          filters: [{name: 'interval', label: 'Interval', key: 'interval', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'company_name', name: 'Company Name'},
            {key: 'account_number', name: 'Account Number'},
            {key: 'actual_cost', name: 'Actual Cost'},
            {key: 'budget_cost', name: 'Budget Cost'},
          ]
        },
        {
          label: 'Top Suppliers List',
          end_point: 'top-suppliers-by-order',
          filters: [{ name: 'limit', label: 'No. of Suppliers', key: 'limit', value: [], raw_filters: true },],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'rank', name: 'Rank'},
            {key: 'name', name: 'Supplier Name'},
            {key: 'account_number', name: 'Account Number'},
            {key: 'country', name: 'Country'},
            {key: 'total_amount', name: 'Total Spend (£)'},
            {key: 'total_orders', name: 'Total Orders'},
            {key: 'avg_order_amount', name: 'Average Order Value (£)'},
          ],
          expanded_table: {
            data_key: 'raw_materials',
            data_label: 'Raw Materials',
            table_keys: [
              {key: 'order_count', name: 'Order Count'},
              {key: 'raw_material_code', name: 'RM Code'},
              {key: 'raw_material_name', name: 'RM Name'},
              {key: 'total_amount', name: 'Total Amount (£)'},
            ],
          },
          view_download_button: 'top-suppliers-by-orders'
        },
        {
          label: "Top Suppliers by Quantity (KG)",
          end_point: 'top-raw-materials-by-order',
          filters: [{ name: 'limit', label: 'No. of Rms', key: 'limit', value: [], raw_filters: true },],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'rank', name: 'Rank'},
            {key: 'code', name: 'RM Code'},
            {key: 'supplier', name: 'Supplier'},
            {key: 'account_number', name: 'Account Number'},
            {key: 'country', name: 'Country'},
            {key: 'total_quantity', name: 'Total Quantity (KG)'},
            {key: 'total_orders', name: 'Total Orders'},
            {key: 'avg_order_quantity', name: 'Average Order Qty (KG)'},
          ],
          view_download_button: 'top-raw-materials-by-orders'
        },
        {
          label: 'Total Expenditure',
          end_point: 'po-expenditure',
          filters: [
            {name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
            {name: 'types', label: 'Type', key: 'type', value: []},
          ],
          yaxis: 'Expenditure (GBP)',
          xaxis: 'Time',
          report_type: 'graph'
        },
        {
          label: 'Total Raw Material Stock in Warehouse',
          end_point: 'raw-material-stock',
          filters: [
            {name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},
            {name: 'countries', label: 'Country', key: 'country', value: []},
          ],
          yaxis: 'RM Stock',
          xaxis: 'Time',
          report_type: 'graph'
        },
        {
          label: 'Total Customer Joined',
          end_point: 'customer-statistics',
          filters: [{name: 'stages', label: 'Customer Stage', key: 'stage', value: []},],
          yaxis: 'Customers',
          xaxis: 'Time',
          report_type: 'graph'
        },
        {
          label: 'Work Orders In Pipeline',
          end_point: 'work-order-employee-statistics',
          filters: [{name: 'status', label: 'Status', key: 'status', value: []},],
          yaxis: '',
          xaxis: '',
          report_type: 'table',
          table_keys: [
            {key: 'work_order_code', name: 'Work Order Code'},
            {key: 'formulation_code', name: 'Formulation Code'},
            {key: 'formulation_name', name: 'Formulation Name'},
            {key: 'work_order_date', name: 'Work Order Date'},
            {key: 'start_time', name: 'Start Time'},
            {key: 'end_time', name: 'End Time'},
            {key: 'q_c_status', name: 'QC Status'},
            {key: 'status', name: 'Status'}
          ]
        },
// {
//   label: 'All Margin', end_point: 'all-sales-margin',
//   filters: [
//     {name: 'interval', label: 'Interval', key: 'interval', value: []},
//   ],
//   yaxis: '' , xaxis: 'Time',
//   report_type: 'multi_line_graph'
// },


// {
//   label: 'Traceability Report', end_point: 'tracebility-report',
//   filters: [
//     {name: 'rm_batch_code', label: 'Rm Batch Code', key: 'rm_batch_code', value: [], type:"input-field"},
//   ],
//   yaxis: '', xaxis: '',
//   report_type: 'table',
//   table_keys:[
//     {key:'batch_code', name: 'Batch Code'},
//     {key:'total_quantity', name: 'Total Quantity'},
//     {key:'available_quantity', name: 'Available Quantity'},
//     {key:'manufacture_date', name: 'Manufacture Date'},
//     {key:'expiration_date', name: 'Expiration Date'},
//     {key:'status', name: 'Status'},
//   ],
//   view_detail_page: 'tracebility-report'
// },

// {
//   label: 'Sales Order Dispatch', end_point: 'sales-orders-dispatched',
//   filters: [
//     {name: 'interval', label: 'Interval', key: 'interval', value: []},
//   ],
//   yaxis: '' , xaxis: 'Time',
//   report_type: 'multi_line_graph'
// },
// {
//   label: 'Cost of Sales by Formulation Type', end_point: 'sales-formulation-type',
//   filters: [
//     {name: 'interval', label: 'Interval', key: 'interval', value: []},
//   ],
//   yaxis: '' , xaxis: 'Time',
//   report_type: 'multi_line_graph'
// },

{
  label: 'List of all Purchase Orders', end_point: 'purchase-order-list',
  filters: [
    {name: 'interval', label: 'Interval', key: 'interval', value: []},
    {name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},
    {name: 'countries', label: 'Country', key: 'country', value: []},
  ],
  yaxis: '', xaxis: '',
  report_type: 'table',
  table_keys:[
    {key:'purchase_order_code', name: 'Purchase Order Code'},
    {key:'supplier_name', name: 'Supplier Name'},
    {key:'supplier_account_number', name: 'Supplier Account Number'},
    {key:'supplier_country', name: 'Supplier Country'},
  ]
},
// {
//   label: 'List of all Purchase Orders', end_point: 'purchase-order-list',
//   filters: [
//     {name: 'interval', label: 'Interval', key: 'interval', value: []},
//     {name: 'suppliers', label: 'Supplier', key: 'supplier_id', value: []},
//     {name: 'countries', label: 'Country', key: 'country', value: []},
//   ],
//   yaxis: '' , xaxis: 'Time',
//   report_type: 'multi_line_graph'
// },
      ],
      range_list: [
        {label: 'This Month', value: '30'},
        {label: 'Previous Month', value: '60'},
        {label: 'This Quarter', value: '90'},
        {label: 'Previous Quarter', value: '180'},
        {label: 'This Year', value: '365'},
        {label: 'Previous Year', value: '600'},
      ],
    }
  },
  mounted() {
    const arr = this.current_user_reports.map((x) => x.name)
    this.allowed_chart_list = this.chart_list.filter((x) => arr.includes(x.label))
  },
  mixins: [ErrorMessages, SuccessMessage],
  methods: {
    openSideBar() {
      setTimeout(() => {
        this.active = true
      }, 10)
    },
    async onClickSave() {
      Object.assign(this.line_chart_data, this.chart_data.line_chart_data)
      Object.assign(this.pie_chart_data, this.chart_data.pie_chart_data)

      let chart_data = {}
      const payload = this.form


      if (this.chart_obj.report_type !== 'table') {
        if (this.form.chart_type !== 'pie') {
          chart_data = this.line_chart_data
          chart_data.chart_options.xaxis.title.text = this.form.xaxis
          chart_data.chart_options.yaxis.title.text = this.form.yaxis
// chart_data.series = [
//   { name: '', data: [] }
// ]
        }
        if (this.form.chart_type === 'pie') {
          chart_data = this.pie_chart_data
          chart_data.chart_options.labels = []

//NEED TO REMOVE AFTER
          payload.xaxis = 'TIME'
          payload.yaxis = 'TEST'
// chart_data.series = []
        }
        payload.from = '12/02/2021'
        payload.to = '12/02/2022'
        payload.configs = chart_data.chart_options
      } else {
        payload.from = '12/02/2021'
        payload.to = '12/02/2022'
        delete payload.chart_type
        payload.configs = {
          table_keys: this.chart_obj.table_keys,
          expanded_table: this.chart_obj.expanded_table,
// view_detail_page: this.chart_obj.view_detail_page ? this.chart_obj.view_detail_page : ''
        }
      }
      if (this.chart_obj.view_download_button) {
        payload.configs.view_download_button = this.chart_obj.view_download_button
      }
      if (this.chart_obj.hide_chart) {
        payload.configs.hide_chart = this.chart_obj.hide_chart
      }

      await this.onClickCreateChart(payload)
      location.reload()
// ccc
    },
    async onClickCreateChart(payload) {
      try {
        await ReportingRepository.createChart(payload)
        this.showSuccessMessage('Chart create successfully')
        this.active = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onSelectChart() {
      this.form.chart_name = this.chart_obj.label
      this.form.actual_name = this.chart_obj.label
      this.form.report_type = this.chart_obj.report_type
      this.form.filters = this.chart_obj.filters
      this.form.endpoint = this.chart_obj.end_point

      if (this.chart_obj.report_type !== 'table') {
        this.form.yaxis = this.chart_obj.yaxis
        this.form.xaxis = this.chart_obj.xaxis
      }
    }
  },
  computed: {
    ...mapGetters(['current_user_reports']),
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
}

</script>


<style lang="scss">
#theme-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}

.customizer-btn {
  position: fixed;
  top: 10%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;

  /*.vs-icon {*/
  /*  animation: spin 1.5s linear infinite;*/
  /*}*/
}

.scroll-area--customizer {
  height: calc(100% - 5rem);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 1000px;
  height: 1000px;
}
</style>

